<template>
	<div class="date__item">
		<div class="form-group">
			<label class="label date__label" :for="id">{{label}}</label>
			<input
				autocomplete="off"
				:class="[getClass, {'input--error' : validate.$error}]"
				v-model="m"
				:name="name"
				:id="id"
				type="number"
				pattern="[0-9]*">
		</div>
	</div>
</template>

<script>
export default {
	name: 'DateOfBirthInput',
	props: {
		id: {
			type: String,
			required: true,
			default: null
		},
		name: {
			type: String,
			required: true,
			default: null
		},
		type: {
			type: String,
			required: true,
			default: null
		},
		label: {
			type: String,
			required: true,
			default: null
		},
		value: {
			type: String,
			default: ""
		},
		validate: {
			type: Object,
			required: false
		}
	},
	data() {
		return {
			getClass: "input date__input--" + this.type,
		}
	},
	computed: {
		m: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			}
		}
	}
}
</script>